import { render } from "./MouseWheelIcon.vue?vue&type=template&id=0488f82e"
import script from "./MouseWheelIcon.vue?vue&type=script&lang=js"
export * from "./MouseWheelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__